import { useEffect } from 'react'
import { useBucket, useExperimentVariables } from '@mc/experiments-react'
import { reportError } from '@mc/next-newrelic'
import { EXPERIMENT_FLAG } from '../constants'
import { parseCmLayout } from '../variables'

export const useMCProPromoCmLayout = () => {
  const bucket = useBucket(EXPERIMENT_FLAG)
  const variables =
    useExperimentVariables<Record<string, unknown>>(EXPERIMENT_FLAG)
  const { cmLayout, isInvalid } = parseCmLayout(variables)
  const shouldReportInvalid = isInvalid && !!bucket

  useEffect(() => {
    if (shouldReportInvalid) {
      reportError(new Error(`Invalid ${EXPERIMENT_FLAG} cmLayout variable`), {
        flag: EXPERIMENT_FLAG,
        variables: JSON.stringify(variables),
      })
    }
  }, [shouldReportInvalid, variables])

  return bucket ? cmLayout : undefined
}
